import React from 'react';
import Icon from '../../../../../../components/icons/Icon';
import { ImMNElement } from '../../../../../../../common/elements/elementModelTypes';
import { getElementId, getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';

type Props = {
    userRootPath?: ImMNElement[];
    handleCreateLabel: (boardId: string) => void;
};

const LabelsCreateButtons = (props: Props) => {
    const { userRootPath, handleCreateLabel } = props;

    if (!userRootPath) return null;

    return (
        <ul className="LabelsCreateButtons mt-2">
            {userRootPath.map((board, index) => {
                const boardId = getElementId(board);
                return (
                    <li
                        key={boardId}
                        className={` flex flex-row cursor-pointer`}
                        onClick={() => handleCreateLabel(boardId)}
                        style={{ marginLeft: `${index * 2}rem` }}
                    >
                        <Icon name="plus" />
                        <span className={`text-left ml-1`}>
                            New label in
                            {'\u00A0'}
                            <span className="font-bold">{getTitle(board)}</span>
                        </span>
                    </li>
                );
            })}
        </ul>
    );
};

export default LabelsCreateButtons;
